<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chap-title"><a id="pagexiii"></a><a href="#/07_Contents#pro" id="pro">Prologue</a></h1>
<h1 class="chap-author"><em>Leon Fleisher</em></h1>
<p class="paranoindent1">A man of infinite sweetness and gentleness. Eyes that danced with delight, aglitter with anticipation; speech that would occasionally hesitate as a flash of insight, a <em>coup de foudre</em> of inspiration would illumine his visage, a new awareness, a hitherto unseen relationship discovered.</p>
<p class="paraindent1" style="padding-top:0.5em">His willingness to introduce to a ten-year-old the mythology of a Mahler First Symphony (4 hands, 1 piano) left its indelible mark.</p>
<p class="paraindent1" style="padding-top:0.5em">His cherubic countenance, wreathed in a kind of perpetual epiphany, embodied the limitless joy and transformation that await us all if we but seek.</p>
<p class="pararight" style="margin-top: 1.5em"><img alt="image" src="images/chap0_pagexiii_fig0.jpg" style="max-width:100%"/><br/>Leon Fleisher</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Prologue.vue?d491f884